function changeUnits(units) {
    const containers = document.querySelectorAll('.size-chart-wrapper')
    if (containers.length > 0) {
      containers.forEach(container => {
        const sizeChart = container.querySelector("#sizeChart");
        const rows = sizeChart.querySelectorAll("tr");
  
        for (let i = 1; i < rows.length; i++) {
          let cols = rows[i].querySelectorAll("td");
          for (let j = 1; j < cols.length; j++) {
            let value = parseFloat(cols[j].getAttribute("data-" + units));
            cols[j].innerText = value.toFixed(1);
          }
        }

        const tabs = container.querySelectorAll(".tab");
        tabs.forEach(tab => {
          if (tab.classList.contains("active")) {
            tab.classList.remove("active")
          }
        });

        container.querySelector(`#${units}`).classList.add("active")
      });
    }
}
  
// Enter "cm" units on page load
document.addEventListener("DOMContentLoaded", function() {
    changeUnits("cm");
});

// Change units on click
document.addEventListener('click', e => {
  if (!e.target.classList.contains('st-change-unit')) {
    return
  }

  const unit = e.target.id 
  changeUnits(unit)
})

// PDP Size Chart Tooltip
document.addEventListener('tooltip:open', e => {
  changeUnits("cm");
});